import { useEffect, useState } from "react";
import { UserRound, Loader2, Save, Eye, Smartphone, Monitor } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { Switch } from "./ui/switch";
import { Button } from "./ui/button";
import { useAuth } from "../context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { ClienteStudioHeader } from "../pages/clientearea/ClienteStudioHeader";
import { ClienteBrand } from "../pages/clientearea/ClienteLogin";

const HeaderPreview = ({ data, onClose }) => {
  const [mobile, setMobile] = useState(false);
  return (
    <Dialog open={!!data} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-4xl" data-testid="area-cliente-preview-dialog">
        <DialogHeader><DialogTitle>Anteprima intestazione Area Riservata</DialogTitle></DialogHeader>
        <div className="flex gap-2">
          {[[false, "Computer", Monitor], [true, "Smartphone", Smartphone]].map(([m, l, I]) => (
            <button key={l} type="button" onClick={() => setMobile(m)} data-testid={`area-cliente-preview-${m ? "mobile" : "desktop"}`}
              className={`flex items-center gap-1.5 rounded-md border px-3 py-1.5 text-xs font-semibold transition-colors ${mobile === m ? "border-amber-500 bg-amber-50 text-amber-800" : "border-slate-300 text-slate-600 hover:bg-slate-100"}`}>
              <I className="h-3.5 w-3.5" />{l}
            </button>
          ))}
        </div>
        <div className={`mx-auto w-full ${mobile ? "max-w-[390px]" : ""} rounded-xl border border-slate-300 overflow-hidden pgp-grid-bg transition-[max-width] duration-300`} data-testid="area-cliente-preview-frame">
          <div className="bg-white/95 border-b border-slate-200 px-4 h-14 flex items-center"><ClienteBrand /></div>
          <div className="p-3 sm:p-5">{data && <ClienteStudioHeader data={data} />}</div>
        </div>
        <p className="text-xs text-slate-500">L'anteprima usa le scelte attuali, anche se non ancora salvate.</p>
      </DialogContent>
    </Dialog>
  );
};

const OPTS = [
  ["logo", "Logo studio"], ["nome", "Nome studio"], ["indirizzo", "Indirizzo"], ["telefono", "Telefono e cellulare"],
  ["email", "Email"], ["pec", "PEC"], ["sito_web", "Sito web"],
];

export const AreaClienteHeaderSettings = () => {
  const { user } = useAuth();
  const isOwner = ["titolare", "amministratore"].includes(user?.role);
  const [val, setVal] = useState(null);
  const [saving, setSaving] = useState(false);
  const [preview, setPreview] = useState(null);
  const openPreview = async () => {
    try { const { data } = await api.post("/studio/area-cliente-header/preview", val); setPreview(data); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  useEffect(() => { if (isOwner) api.get("/studio/area-cliente-header").then(({ data }) => setVal(data)).catch(() => {}); }, [isOwner]);
  const save = async () => {
    setSaving(true);
    try { const { data } = await api.put("/studio/area-cliente-header", val); setVal(data); toast.success("Personalizzazione salvata"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setSaving(false); }
  };
  if (!isOwner) return null;
  return (
    <div id="sez-area-cliente" className="pgp-card p-6 max-w-2xl mt-6 pgp-fade-up" data-testid="area-cliente-header-config">
      <h3 className="font-head font-semibold text-slate-100 flex items-center gap-2"><UserRound className="h-4 w-4 text-amber-400" /> Personalizzazione Area Riservata Cliente</h3>
      <p className="text-sm text-slate-400 mt-1">Scegli cosa mostrare nell'intestazione dell'Area Riservata dei tuoi clienti. I dati sono quelli inseriti in Dati Studio.</p>
      {!val ? <Loader2 className="h-5 w-5 animate-spin text-amber-500 mt-4" /> : (
        <>
          <div className="mt-4 grid sm:grid-cols-2 gap-2">
            {OPTS.map(([k, l]) => (
              <label key={k} className="flex items-center justify-between rounded-lg border border-slate-800 bg-slate-900/40 px-4 py-2.5 cursor-pointer">
                <span className="text-sm text-slate-200">{l}</span>
                <Switch checked={!!val[k]} onCheckedChange={(v) => setVal({ ...val, [k]: v })} data-testid={`area-cliente-header-${k}`} className="data-[state=checked]:bg-amber-500" />
              </label>
            ))}
          </div>
          <div className="mt-4 flex flex-wrap gap-2">
            <Button type="button" onClick={save} disabled={saving} data-testid="area-cliente-header-save" className="bg-amber-500 hover:bg-amber-600 text-[#0a0d14] font-semibold">
              {saving ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : <Save className="h-4 w-4 mr-1" />} Salva
            </Button>
            <Button type="button" variant="outline" onClick={openPreview} data-testid="area-cliente-header-preview">
              <Eye className="h-4 w-4 mr-1" /> Anteprima
            </Button>
          </div>
          <HeaderPreview data={preview} onClose={() => setPreview(null)} />
        </>
      )}
    </div>
  );
};
